export const prettyOpenBankingLabel = (label) => {
  if (!label) {
    return "";
  }
  if (typeof label !== "string") {
    return label;
  }
  // const splitWordsOnForwardSlash = /(?<=^|\/)\w/g;
  // return label
  //   .replaceAll("_", " ")
  //   .replace(/(?<=^|\/)([^/]+)(\/\1)+(?=$|\/)/g, "$1")
  //   .replace(splitWordsOnForwardSlash, (v) => v.toUpperCase())
  //   .replaceAll("/", ": ");

  let normalText = label
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");

  // Optionally capitalize the first letter of the resulting string
  return normalText.charAt(0).toUpperCase() + normalText.slice(1);
};
